import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { GetClient, PostClientComingToCanadaInfo } from '../services/httpServices';

import styled from '@emotion/styled';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const ComingToCanada = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [loading, setLoading] = useState(true);

  const [client, setClient] = useState({});

  const [purposOfComing, setPurposOfComing] = useState('Tourism');

  const placeOfEntryRef = useRef('');
  const dateOfEntryRef = useRef('');
  const placeOfMostRecentEntryRef = useRef('');
  const dateOfMostRecentEntryRef = useRef('');
  const otherPurposeOfComingRef = useRef('');

  const fetchClient = async (event) => {
    const client = await GetClient(props.id);

    setPurposOfComing(client?.comingToCanadaInfos[0]?.purposeOfComing);
    setClient(client);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, []);

  const SaveUser = async (event) => {
    // setPosting(true);
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      id: props.id,
      placeOfEntry: placeOfEntryRef.current.value,
      dateOfEntry: dateOfEntryRef.current.value,
      mostRecntDateEntry: dateOfMostRecentEntryRef.current.value,
      mostRecntPlaceEntry: placeOfMostRecentEntryRef.current.value,
      purposeOfComing: purposOfComing,
      otherPurposeOfComing: otherPurposeOfComingRef.current.value,
    };

    //console.log(payload);
    let response = await PostClientComingToCanadaInfo(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
      let clientSaved = client;
      clientSaved.comingToCanadaInfos[0] = response.data;
      setClient(clientSaved);
      // setTimeout(() => {
      //   navigate(`/app/EditClient/${response.data.id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const handleChangePurpose = (event) => {
    setPurposOfComing(event.target.value);
    if (event.target.value == 'Other') {
      otherPurposeOfComingRef.current.value = client?.comingToCanadaInfos[0]?.otherPurposeOfComing;
    } else {
      otherPurposeOfComingRef.current.value = '';
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Place of first entry to Canada"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.comingToCanadaInfos[0]?.placeOfEntry}
                      inputRef={placeOfEntryRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Date of first entry to Canada"
                      type="date"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.comingToCanadaInfos[0]?.dateOfEntry?.split('T')[0]}
                      inputRef={dateOfEntryRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Place of most recent entry to Canada"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.comingToCanadaInfos[0]?.mostRecntPlaceEntry}
                      inputRef={placeOfMostRecentEntryRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Date of most recent entry to Canada"
                      type="date"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.comingToCanadaInfos[0]?.mostRecntDateEntry?.split('T')[0]}
                      inputRef={dateOfMostRecentEntryRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Purpose for coming to Canada:</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={purposOfComing}
                        row
                        onChange={handleChangePurpose}
                      >
                        <FormControlLabel value="Tourism" control={<Radio />} label="Tourism" />
                        <FormControlLabel value="Work" control={<Radio />} label="Work" />
                        <FormControlLabel value="Study" control={<Radio />} label="Study" />
                        <FormControlLabel value="Other" control={<Radio />} label="Other" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Other purpose of coming to Canada"
                      required
                      variant="outlined"
                      fullWidth
                      disabled={purposOfComing != 'Other' ? true : false}
                      size="small"
                      defaultValue={client?.comingToCanadaInfos[0]?.otherPurposeOfComing}
                      inputRef={otherPurposeOfComingRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default ComingToCanada;
